import { DateValue, fDate } from '@aibees/shared/utils';

export const formatButtonDateValues = (date: DateValue) => {
  if (date) {
    return fDate(date, 'dd MMM yyyy');
  }
  return '';
};
